import { UserModal } from '../../../../../UserModal/UserModal';
import { useGCUserModal } from '../../../../../../hooks/useGCUserModal';
import LoadPanel from 'devextreme-react/load-panel';
import '../../../../../../scss/_byUserPanel.scss';

export interface GCUserLinkProps {
    authorizedDrawUserId: number;
    firstName: string;
    lastName: string;
    onRefresh: () => void;
}

export const GCUserLink: React.FC<GCUserLinkProps> = ({ authorizedDrawUserId, firstName, lastName, onRefresh }) => {
    const modal = useGCUserModal(onRefresh);
    const combinedName = `${firstName} ${lastName}`;

    return (
        <>
            {firstName && lastName && <a onClick={() => modal.loadAndOpen(authorizedDrawUserId)}>{combinedName}</a>}
            {!firstName && !lastName && <div>Name not provided</div>}
            <LoadPanel
                hideOnOutsideClick={false}
                visible={modal.isLoading}
                message='Loading user...'
            />
            <UserModal
                isOpen={modal.isOpen}
                onSubmitAsync={modal.onSubmitAsync}
                onClose={modal.close}
                authorizedDrawUser={modal.authorizedDrawUser}
            />
        </>
    );
};
